var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5547,
    cy: 24.5098,
    rx: 25,
    ry: 24.5098,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4176 25.075C26.1879 25.2823 25.8895 25.397 25.5801 25.397C25.2707 25.397 24.9723 25.2823 24.7426 25.075L14.1426 15.4375C14.5585 15.1526 15.0509 15.0001 15.5551 15H35.5551C36.0593 15.0001 36.5516 15.1526 36.9676 15.4375L26.4176 25.075Z",
    fill: "#7A53FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0547 17.825V31.25C38.0547 32.2445 37.6596 33.1983 36.9563 33.9016C36.2531 34.6049 35.2992 35 34.3047 35H16.8047C15.8101 35 14.8563 34.6049 14.153 33.9016C13.4498 33.1983 13.0547 32.2445 13.0547 31.25V17.825L23.9047 27.725C24.3623 28.1224 24.9486 28.34 25.5547 28.3375C26.1683 28.3362 26.76 28.1093 27.2172 27.7L38.0547 17.825Z",
    fill: "#7A53FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.2037961773e03f695949efee61db60e8.svg";
export { ForwardRef as ReactComponent };